import {useContext} from 'react';

import {InjectionContext} from '../components/InjectionContext';

export const useInjectionContext = () => {
  const context = useContext(InjectionContext);

  if (!context) {
    throw new Error(
      'Injection context not found. Seems like you forget to use InjectionProvider!',
    );
  }

  return context;
};
